import { render, staticRenderFns } from "./AddthroughConfiguration.vue?vue&type=template&id=5fc29cb5&scoped=true&"
import script from "./AddthroughConfiguration.vue?vue&type=script&lang=js&"
export * from "./AddthroughConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc29cb5",
  null
  
)

export default component.exports